import { endpointPortfolioCompanyLogoPOST } from '~/api/def/endpoints/portfolioCompanyEndpoint';

export const uploadLogo = async (
  file: File,
  companyId: string,
): Promise<string> => {
  const formData = new FormData();

  formData.append('file', file);

  try {
    const uploadResponse = await endpointPortfolioCompanyLogoPOST(
      companyId,
      formData,
    );

    return uploadResponse.data.logoFileKey as string;
  } catch (error) {
    throw new Error('Failed to upload logo');
  }
};
